import { Application } from "@hotwired/stimulus"
import "../offline_queue"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
